<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                date: '',
                company_id: '',
                amount: '',
                type_payment_id: '',
                employees: [],
                amounts: [],
                payments: [],
                bank_accounts: [],
                files: [],
                description: '',
            },
            files: [],
            send: false,
        }
    },
    methods: {
        resetAmount(userId) {
            if (!this.form.employees.includes(userId)) {
                this.$set(this.form.amounts, 'id_' + userId, 0);
                this.$set(this.form.payments, 'id_' + userId, 0);
                this.$set(this.form.bank_accounts, 'id_' + userId, 0);
            }
        },
        closedModal() {
            this.form.id = '';
            this.form.company_id = '';
            this.form.date = '';
            this.form.amount = '';
            this.form.employees = [];
            this.form.amounts = [];
            this.form.files = [];
            this.form.payments = [];
            this.form.bank_accounts = [];
            this.form.type_payment_id = '';
            this.form.description = '';
            this.files = [];
            this.send = false;
            this.errors = {};
            this.$modal.hide('addPayroll');
        },
        uploadFilesBill(event) {
            let vm = this;

            let file = event.target.files[0];
            // let allowedImageTypes = ["image/jpeg", "image/gif", "image/png"];
            // if (!allowedImageTypes.includes(file.type)) {
            //     this.$swal({
            //         icon: 'error',
            //         title: 'Error en el tipo de archivo',
            //         text: 'Solo se acepta archivo tipo imagen',
            //     });
            // } else {
            vm.form.files.push(file);
            console.log(vm.form.files);
            this.$forceUpdate();

            // }
        },
        createURL(file) {
            let link = URL.createObjectURL(file);
            return link;
        },
        calcTotal() {
            this.form.amount = this.form.subtotal + this.form.iva + this.form.ieps - this.form.isr_ret - this.form.iva_ret - this.form.discount;
        },
        calcTotalUSD() {
            this.form.subtotal = this.form.exchange_rate * this.form.amount_usd;
        },
        async delImgUpload(pos) {
            let img = this.files[pos];
            let id = img.id;
            let _endpoint = '/payroll/deleted-documents';
            let form = {
                id: id
            };
            let { data } = await request.postMedia(_endpoint, form)
            if (data) {
                this.successNotification(data.message);
                this.files.splice(pos, 1);
            }

        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
        catch_file(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_xml(event) {
            console.log(event.target.files[0].type);
            if (event.target.files[0].type == "text/xml") {
                this.form.xml = event.target.files[0];
                this.xmlName = event.target.files[0].name;
                this.catchDataXML(event.target.files[0]);


            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos XML',
                });
            }
        },
        async saveBuildings() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('company_id', this.form.company_id);
            data_form.append('date[0]', this.form.date[0]);
            data_form.append('date[1]', this.form.date[1]);
            data_form.append('amount', this.form.amount);
            data_form.append('payments', this.form.payments);
            data_form.append('bank_accounts', this.form.bank_accounts);
            data_form.append('type_payment_id', this.form.type_payment_id);
            data_form.append('description', this.form.description)

            this.form.files.forEach(function (valor, index) {
                data_form.append('files[' + index + ']', valor);
            });

            const employeesArray = this.form.employees.map(id => ({
                id,
                amounts: this.form.amounts['id_' + id] || 0,
                payments: this.form.payments['id_' + id] || 0,
                bank_accounts: this.form.bank_accounts['id_' + id] || 0,
            }));

            data_form.append('employees', JSON.stringify(employeesArray));

            let _endpoint = '/payroll';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/payroll/${this.form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    console.log(data);
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-payroll');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        // Check
        getBuysBudgets(user_id) {
            console.log('paso0');
            console.log(user_id);
            console.log(this.form.concept_id);

            if (user_id && this.form.check_type_id) {
                console.log('paso');
                let company_id = this.form.company_id;
                this.catalogue.get_budgets_user(user_id, this.form.check_concept_id, company_id);
                this.catalogue.get_buys_user(user_id, this.form.check_concept_id, company_id);
            }
        },
        getDataBudget() {
            let budgets = this.catalogue.budgets_user;
            console.log(budgets);

            let budget_id = this.form.check_budget_id;
            let res = budgets.find((s) => s.id === budget_id);
            console.log(res.concept_id);
            this.form.check_concept_id = res.concept_id;
        },
        getDataBuy() {
            let buys = this.catalogue.buys_user;
            console.log(buys);
            let buy_id = this.form.check_buy_id;
            console.log(buy_id);
            let res = buys.find((s) => s.id === buy_id);
            console.log(res);
            this.form.check_concept_id = res.concept_id;
        },
        updateTotal() {
            // Recalcula la suma total
            const total = Object.values(this.form.amounts).reduce((sum, amount) => {
                return sum + (parseFloat(amount) || 0); // Convierte el valor a número o usa 0 si es inválido
            }, 0);
            this.form.amount = total.toFixed(2);

        },

        validate_payment(id){
            if((document.getElementById('type_payment-' + id).options[document.getElementById('type_payment-' + id).selectedIndex].text=='Transferencia'
                ||document.getElementById('type_payment-' + id).options[document.getElementById('type_payment-' + id).selectedIndex].text=='Dispersión')
                &&!document.getElementById('bank_accounts-' + id)){
                document.getElementById('type_payment-' + id).value=5;
                this.form.payments['id_' + id] = 5;
                this.$swal('Para seleccionar esta forma de pago es necesario que el empleado tenga una cuenta bancaria');
            }
        },
		selectAll() {
			let selected = this.form.employees;
			this.catalogue.company_user.forEach(element => {
				if (!selected.includes(element.id)) {
					selected.push(element.id);
				}
			});
		},
		deselectAll() {
            this.form.employees = [];
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
        'form.company_id'(value) {
            this.catalogue.get_company_user_payroll(value);
        },
        'form.employees'() {
            // handler() {
            this.updateTotal();
            // },
            // deep: true
        },
        // Observa los cambios en los montos
        'form.amounts'() {
            console.log('form.amounts');
            // handler() {
            this.updateTotal();
            // },
            // deep: true
        }
    },
    mounted() {
        if (this.authUser.organization_charts_id != 1) {
            this.catalogue.get_companies_users(this.authUser.id);
        } else {
            this.catalogue.get_company_pays();
        }
        this.catalogue.get_type_payments_payroll();

    },
    created() {
        Event.$on("event-show-addPayroll", async (payroll) => {
            if (payroll.id) {
                this.load = true;
                this.form.id = payroll.id;
                this.form.company_id = payroll.company_id;
                this.form.date = [payroll.date_start, payroll.date_end];
                this.form.type_payment_id = payroll.type_payment_id;
                this.form.description = payroll.description;
                await this.catalogue.get_company_user_payroll(payroll.company_id);

                payroll.users.forEach(user => {
                    console.log(user);
                    this.form.employees.push(user.id);
                    this.form.amounts['id_' + user.id] = user.pivot.amount;
                    this.form.payments['id_' + user.id] = user.pivot.payment_id;
                    this.form.bank_accounts['id_' + user.id] = user.pivot.bank_account_id;
                });

                if (payroll.files) {
                    this.files = payroll.files;
                }

                this.form.amount = payroll.amount;

            }
            this.updateTotal();
            this.$modal.show('addPayroll');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addPayroll" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Agregar N&oacute;mina</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-3">
                        <label>Empresa</label>
                        <select v-model="form.company_id" :disabled="!prop_edit" class="form-control"
                            v-if="authUser.organization_charts_id == 1">
                            <option value=""> Sin empresa </option>
                            <option v-for="(company, index) in catalogue.company_pays" :value="company.id" :key="index">
                                {{ company.name }}</option>
                        </select>

                        <select v-model="form.company_id" :disabled="!prop_edit" class="form-control" v-else>
                            <option value=""> Sin empresa </option>
                            <option v-for="(company, index) in catalogue.companies_users" :value="company.id"
                                :key="index">
                                {{ company.name }}</option>
                        </select>

                        <div v-if="errors && errors.company_id" class="text-danger">
                            {{ errors.company_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Periodo</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" required="required"
                             :range="true" valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-12 mt-3">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Seleccionar
                                        <button v-if="prop_edit" class="btn btn-sm btn-info" @click.prevent="selectAll">
                                            <i class="fa-solid fa-check-square"></i>
                                        </button>
                                        <button v-if="prop_edit" class="btn btn-sm btn-info" @click.prevent="deselectAll">
                                            <i class="fa-solid fa-square"></i>
                                        </button>
                                    </th>
                                    <th>Empleado</th>
                                    <th>Forma de pago</th>
                                    <th>Cuenta bancaria</th>
                                    <th>Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, index_user) in catalogue.company_user" :key="index_user">
                                    <td>
                                        <input :disabled="!prop_edit" type="checkbox" v-model="form.employees"
                                            :value="user.id" @change="resetAmount(user.id)" class="form-control"
                                            :id="'id-' + user.id">
                                    </td>
                                    <td>
                                        <div v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == form.company_id })">
                                        <!-- <div v-if="authUser.companies.includes(form.company_id)"> -->
                                            {{ user.name }} {{ user.last_name }}
                                        </div>
                                        <div v-else>
                                            XXXXXXX XXXXXXXX
                                        </div>
                                    </td>
                                    <td>
                                        <select type="text" :disabled="!prop_edit || !form.employees.includes(user.id)"
                                            class="form-control" v-model="form.payments['id_' + user.id]"
                                            :id="'type_payment-' + user.id"
                                            @change="validate_payment(user.id)">
                                            <option v-for="(payment, index_payment) in catalogue.type_payments"
                                                :value="payment.id" :key="index_payment">
                                                {{ payment.name }}
                                            </option>
                                        </select>
                                        <div v-if="errors && errors.payments" class="text-danger">{{
                                            errors.payments[0] }}
                                        </div>
                                    </td>
                                    <td v-if="user.bank_accounts && user.bank_accounts.length > 0">
                                        <select type="text" :disabled="!prop_edit || !form.employees.includes(user.id)"
                                            class="form-control" v-model="form.bank_accounts['id_' + user.id]"
                                            :id="'bank_accounts-' + user.id">
                                            <option v-for="(bank, index_bank) in user.bank_accounts" :value="bank.id"
                                                :key="index_bank">
                                                <span>{{ bank.bank.name }}</span> - {{ bank.account_number }}
                                            </option>
                                        </select>
                                        <div v-if="errors && errors.bank_accounts" class="text-danger">{{
                                            errors.bank_accounts[0] }}
                                        </div>
                                    </td>
                                    <td v-else>Sin cuenta bancaria</td>
                                    <td>
                                        <money @input="updateTotal"
                                            :disabled="!prop_edit || !form.employees.includes(user.id)"
                                            class="form-control" v-model="form.amounts['id_' + user.id]"></money>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                        <div v-if="errors && errors.employees" class="text-danger">{{ errors.employees[0] }}</div>
                    </div>

                    <div class="col-12">
                        <div class="row justify-content-end">
                           <!-- <div class="col-md-6 mt-3">
                                <label>Tipo de saldo</label>
                                <select type="text" :disabled="!prop_edit" class="form-control"
                                    v-model="form.type_payment_id">
                                    <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
                                        :value="type_payment.id" :key="index_type_payment">{{
                                            type_payment.name }}</option>
                                </select>
                                <div v-if="errors && errors.type_payment_id" class="text-danger">{{
                                    errors.type_payment_id[0] }}
                                </div>
                            </div>  -->
                            <div class="col-md-12 mt-3">
                                <label>Total a pagar</label>
                                <money disabled class="form-control"
                                    v-model="form.amount"></money>
                                <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Descripción</label>
                                <textarea type="text" :disabled="!prop_edit" class="form-control"
                                    v-model="form.description"></textarea>
                                <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <hr>
                        <div class="row">
                            <div class="col-12 text-center">
                                <h3>Archivo adjuntos.</h3>
                                <p>Máximo 15 archivos.</p>
                                <div class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length + files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>
                                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in files"
                                        :key="index_fAdd" v-show="files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImgUpload(index_fAdd)">
                                                <i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="`${globalUrlFiles}${fAdd.file}`" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ fAdd.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="index_img" v-show="form.files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)"><i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="createURL(img)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ img.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                        <div v-if="errors && errors.hasOwnProperty('files.'+index_img)" class="text-danger">{{
                                            errors['files.'+index_img][0] }}
                                        </div>

                                    </div>
                                </div>


                                <div class="input-group mb-3"
                                    v-if="(form.files.length + files.length) <= 14 && prop_edit">
                                    <div class="custom-file" @change="uploadFilesBill">
                                        <input type="file" class="custom-file-input" id="inputGroupFile03"
                                            aria-describedby="inputGroupFileAddon03">
                                        <label class="custom-file-label" for="inputGroupFile03">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>